import { ISumPropertyDifferenceBehavior } from "../../../interfaces/form-builder/i-behavior";
import { NoteDataManager } from "../note-data-manager";

export class ListGroupTimeSumDifferenceHandler {
    public handle(sumPropertyDifferenceBehavior: ISumPropertyDifferenceBehavior, noteDataManager: NoteDataManager) {
        let listGroupLength = noteDataManager.getListCount(sumPropertyDifferenceBehavior.listGroupName);
        if (!listGroupLength) {
            return 0;
        }
        let propertyCount = 0;
        let noteModel = noteDataManager.getNoteModel();
        let propertyList = [];
        while (propertyCount < listGroupLength) {
            let minProperty = `${sumPropertyDifferenceBehavior.listGroupName}.${propertyCount}.${sumPropertyDifferenceBehavior.minPropertyName}`;
            let maxProperty = `${sumPropertyDifferenceBehavior.listGroupName}.${propertyCount}.${sumPropertyDifferenceBehavior.maxPropertyName}`;
            if (!!noteModel[minProperty] && !!noteModel[maxProperty]) {
                propertyList.push({ start: noteModel[minProperty], end: noteModel[maxProperty] });
            }
            propertyCount++;
        }
        propertyList = propertyList.filter((property, index) => {
            let filteredElementName = `${sumPropertyDifferenceBehavior.listGroupName}.${index}.${sumPropertyDifferenceBehavior.propertyName}`;
            let filterValue = noteModel[filteredElementName];
            if (Array.isArray(filterValue)) {
                return filterValue.join("") === sumPropertyDifferenceBehavior.values.join("");
            } else {
                return sumPropertyDifferenceBehavior.values.length > 0
                    ? sumPropertyDifferenceBehavior.values.includes(filterValue as any)
                    : !filterValue;
            }
        });
        let totalMinutes = propertyList.reduce((acc, current) => {
            let minMinutes = this.timeToMinutes(current.start as string);
            let maxMinutes = this.timeToMinutes(current.end as string);

            let diff = maxMinutes - minMinutes;

            if (diff < 0) {
                diff += 24 * 60;
            }
            return diff + acc;
        }, 0);

        let hours = Math.floor(totalMinutes / 60);
        let remainingMinutes = totalMinutes % 60;

        return `${hours.toString().padStart(2, "0")}:${remainingMinutes.toString().padStart(2, "0")}`;
    }

    private timeToMinutes(timeStr: string) {
        const [time, meridian] = timeStr.split(" ");
        let [hours, minutes] = time.split(":").map(Number);
        if (meridian === "PM" && hours !== 12) {
            hours += 12;
        }
        if (meridian === "AM" && hours === 12) {
            hours = 0;
        }
        return hours * 60 + minutes;
    }
}
